export const colors = {
  primary: '#f46526',
  greyDark: '#81899c',
  greyPrimary: '#e0e0e0',
  white: '#fff',

  brand025: '#D6E5F9',
  brand050: '#ACCCF3',
  brand100: '#83B2EE',
  brand300: '#5999E8',
  brand500: '#307FE2',
  brand700: '#2666B5',
  brand800: '#1e4f8b',
  brand900: '#123055',
  brandSecondary: '#FFFFFF',
  statew0: '#ffffff00',
  statew1: '#FFFFFF',
  statew2: '#FCFCFC',
  statew3: '#F7F7F6',
  statew4: '#EEEDF0',
  grey025: '#F0F5FA',
  grey050: '#EBF0F5',
  grey100: '#DDE2E6',
  grey200: '#CACED1',
  grey300: '#B4B7BA',
  grey400: '#8E969E',
  grey500: '#656B70',
  grey600: '#45494C',
  grey700: '#373A3D',
  grey800: '#1E2021',
  grey900: '#101112',
  info025: '#F5FAFF',
  info050: '#F0F8FF',
  info100: '#E0F1FF',
  info300: '#96CBFA',
  info500: '#3995E5',
  info700: '#0A5DA6',
  info900: '#084E8C',
  succ025: '#F5FFF9',
  succ050: '#EDFFF5',
  succ100: '#D6FFE8',
  succ300: '#85E5AF',
  succ500: '#17BD5F',
  succ700: '#258750',
  succ900: '#0B6934',
  warn025: '#FFFBF5',
  warn050: '#FFF9F0',
  warn100: '#FFF4E0',
  warn300: '#FFCA6D',
  warn500: '#E59D20',
  warn700: '#B47304',
  warn900: '#996202',
  error050: '#FFF5F5',
  error100: '#FFF1F0',
  error200: '#FFE1E0',
  error300: '#FF9790',
  error500: '#F04337',
  error700: '#B22A20',
  error900: '#8C1108',
  teal050: '#DBF3FF',
  teal100: '#9EDFFF',
  teal300: '#9EDFFF',
  teal500: '#9EDFFF',
  teal700: '#0E77AB',
  teal900: '#085A83',
  voil050: '#D6DCFF',
  voil100: '#B2BAFE',
  voil300: '#959EF7',
  voil500: '#6969F3',
  voil700: '#5E5EDD',
  voil900: '#5350CE',
};
